import {Component, OnInit, inject} from '@angular/core';
import {TitleCasePipe} from '@angular/common';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatTabsModule} from '@angular/material/tabs';

import {UserService} from 'src/app/services/user.service';
import {User} from '../models/user';
import {FilterDrawerService} from '../services/filter-drawer.service';
import {TopnavComponent} from '../topnav/topnav.component';
import {FeatureFlagDirective} from '../core/feature-flag.directive';

@UntilDestroy()
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    TopnavComponent,
    TitleCasePipe,
    MatTabsModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    FeatureFlagDirective,
  ],
})
export class NavbarComponent implements OnInit {
  private router = inject(Router);
  private userService = inject(UserService);
  filterDrawerService = inject(FilterDrawerService);

  userIsLoggedIn = false;
  hasAdminRole = false;
  hasUserRole = false;
  user: User;
  userFullName: string;

  ngOnInit(): void {
    this.userService.user$.pipe(untilDestroyed(this)).subscribe((user) => {
      this.user = user;
      this.userFullName = this.user.name;
    });
  }
}
